import React, { useState, useEffect } from "react";
import "../../styles/css/UserList.css";
import {
  Button,
  Form,
  Modal,
  Alert,
  Spinner,
  CardColumns,
} from "react-bootstrap";
import NavigationBar from "../NavigationBar";
import micro_reporter_api from "../../apis/micro-reporter-api";
import UserForm from "./UserForm";
import noUser from "../../assets/img/group.png";
import SideNavigation from "../SideNavigation";
import User from "./User";
import searchImage from "../../assets/img/search.png";
import Utils from "../../libraries/utils";

const UserList = () => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  let errorMessage = "An unexpected error was encountered!";

  const [users, setUsers] = useState([]);
  const [tempsUsers, setTempUsers] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [user, setUser] = useState();
  const [showLoad, setShowLoad] = useState(false);

  useEffect(() => {
    getAllUsers();
  }, []);

  const getAllUsers = () => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        setShowLoad(true);
        await micro_reporter_api
          .get("/micro-reporter/user/all-users")
          .then((response) => {
            setUsers(response.data);
            setTempUsers(response.data);
            Utils.loadingScreen("hide");
            setShowLoad(false);
          });
      } catch {
        Utils.loadingScreen("hide");
        setShowErrorMessage(true);
        setShowLoad(false);
      }
    })();
  };

  const renderTable = (users) => {
    if (users.length > 0) {
      return (
        <CardColumns style={{ marginTop: "35px" }}>
          {renderList(users)}
        </CardColumns>
      );
    } else if (!showLoad) {
      return (
        <div id="user-not-found-div">
          <div id="user-list-center-div">
            <img
              src={noUser}
              style={{ width: "100px", marginTop: "20px" }}
              alt="No user found."
            />
            <br />
            <span>No user found, create a new one!</span>
          </div>
        </div>
      );
    }
  };

  const renderList = (users) => {
    return users.map((user) => {
      return (
        <User openUpdateModal={openUpdateModal} user={user} key={user.id} />
      );
    });
  };

  const openUpdateModal = (user) => {
    setUser(user);
    setModalShow(true);
  };

  function NewUserModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <span id="connection-form-panel-title">
              {user === undefined ? "Create a New User" : "Update User"}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserForm user={props.user} />
        </Modal.Body>
      </Modal>
    );
  }

  const search = (word) => {
    let temp = [];
    users.map((user) => {
      let name_surname =
        user?.name?.toLowerCase() + " " + user?.surname?.toLowerCase();
      if (
        user?.name?.toLowerCase().includes(word.toLowerCase()) ||
        user?.surname?.toLowerCase().includes(word.toLowerCase()) ||
        user?.username?.toLowerCase().includes(word.toLowerCase()) ||
        user?.email?.toLowerCase().includes(word.toLowerCase()) ||
        name_surname?.includes(word.toLowerCase())
      ) {
        temp.push(user);
      }
    });
    setTempUsers(temp);
    temp = [];
  };

  return (
    <div>
      <SideNavigation current="users" />
      <div className="page-order">
        <NavigationBar />
        <div id="user-list-panel">
          <NewUserModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            user={user === undefined ? undefined : user}
          />
          <div>
            <h5 className="page-title">Users</h5>
          </div>
          {showErrorMessage ? (
            <Alert variant="danger" style={{ marginBottom: "60px" }}>
              {errorMessage}
            </Alert>
          ) : null}
          <Form>
            <input
              type="text"
              name="search"
              id="userSearchInput"
              onChange={(event) => search(event.target.value)}
              placeholder="Search User"
              className="extand"
            />
            <img id="seacrhIcon" src={searchImage} alt="search" />
          </Form>
          {renderTable(tempsUsers)}
        </div>
      </div>
    </div>
  );
};

export default UserList;
